import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { EnumFilter, SelectedDepartmentFilter } from 'support/filters'
import BackToOverview from 'widgets/navigation/BackToOverview'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import ContractTemplateSmartview from 'pages/app/hr/employments/smartviews/ContractTemplateSmartview'
import { PaginationFilter } from '@morningtrain/react-filters'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function ContractTemplates (props) {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='hr.contracts'>
        <UI.PageHeader title={<TranslatedTitle name='titles.templates'/>}>
          <UI.ButtonWrap>
            <BackToOverview route='app.hr.contracts'>
              <Translation name='actions.back_to_contracts'/>
            </BackToOverview>
            <MountSmartviewOnClick smartview={<ContractTemplateSmartview create/>} replace={false}>
              <UI.Button color='primary'>
                <Translation name='generic.create'/>
              </UI.Button>
            </MountSmartviewOnClick>
          </UI.ButtonWrap>
        </UI.PageHeader>
      </Translator>
      <Collection resourceName='employments.contract_templates'>
        <SelectedDepartmentFilter/>
        <MountSmartviewOnSelection smartview={<ContractTemplateSmartview create={false}/>} replace={false}/>

        <UI.Card>
          <UI.TableHeader>
            <EnumFilter
              name='slug'
              placeholder='-'
              label={<Translation name='filters.contract_slug.label'/>}
              enum='contract_slug'
            />
            <EnumFilter
              name='status'
              placeholder='-'
              enum='active_status'
            />
          </UI.TableHeader>
          <Table>
            <Columns.Text
              name='name'
              label={<Translation name='columns.name.label'/>}
            />
            <Columns.Text
              name='department.name'
              label={<Translation name='columns.department.label'/>}
            />
            <Columns.Text
              name='employment_type.name'
              label={<Translation name='columns.employment_type.label'/>}
            />
            <Columns.Enum
              name='locale'
              enum='language'
            />
            <Columns.Enum
              name='status'
              enum='active_status'
            />
            <Columns.DateTime
              name='updated_at'
            />
          </Table>
          <PaginationFilter/>
        </UI.Card>
      </Collection>
    </AdminPageWithSmartview>
  )
}
